<template>
  <div class="self_evaluation">
    <div class="tabs">
      <span></span>提供服务（可多选）
      <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
        <i v-show="isEdit" class="tabs_one" @click="goEssentialInformation"></i>
      </el-tooltip>
    </div>
    <el-form :inline="true" :label-position="labelPosition" label-width="100px" ref="ruleFormDataOne"
      :model="FormDataOne">
      <el-form-item label="提供服务" prop="user_function" :rules="[
      { required: true, message: '请选择提供服务', trigger: 'blur'}, ]">
        <el-checkbox-group v-model="FormDataOne.user_function" true-label :disabled="isDis">
          <el-checkbox label="翻译" value="1"></el-checkbox>
          <el-checkbox label="译后编辑" value="2"></el-checkbox>
          <el-checkbox label="审校" value="3"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

    </el-form>
    <div class="btn" v-if="!isDis">
      <el-button class="cancel" @click="cancel">取消</el-button>
      <el-button class="preservation" @click="preservation">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object
    }
  },
  computed: {
    isEdit () {
      if (this.auditStatus === 1) {
        return false
      } else {
        return this.isDis
      }
    },
  },
  watch: {
    userInfo: {
      handler (newVale, oldVale) {
        if (newVale.num === 1) {
          this.id = newVale.id
          this.auditStatus = newVale.auditStatus
          this.certificateUrls = newVale.certificateUrls
          if (newVale.userFunctions) {
            this.FormDataOne.user_function = [...newVale.userFunctions]
            this.FormDataOne.user_function.forEach((item, index) => {
              if (item == 1) {
                this.FormDataOne.user_function[index] = "翻译";
              }
              if (item == 2) {
                this.FormDataOne.user_function[index] = "译后编辑";
              }
              if (item == 3) {
                this.FormDataOne.user_function[index] = "审校";
              }
            });


          }
          this.dataObj = { ...this.FormDataOne } // 解构对象，取消操作用解构对象
        }
      },
      deep: true,
      immediate: true
    },
  },
  data () {
    return {
      auditStatus: null,
      FormDataOne: {
        user_function: [], //提供服务
      },
      isDis: true,
      labelPosition: "left",
      dataObj: {},
      id: null,
    };
  },

  methods: {
    goEssentialInformation () {
      this.isDis = false
    },

    async preservation () {
      let verify = true;
      this.$refs.ruleFormDataOne.validateField(["user_function",], errTip => {
        if (errTip) {
          // 会调用多次
          verify = false;
        }
      })
      if (verify) {
        let url = "/v1/userRegister/add_or_update_register_info"
        let myUser = JSON.parse(localStorage.getItem("myUser"))
        let userFunctions = [...this.FormDataOne.user_function]
        userFunctions.forEach((item, index) => {
          if (item == "翻译") {
            userFunctions[index] = 1;
          }
          if (item == "译后编辑") {
            userFunctions[index] = 2;
          }
          if (item == "审校") {
            userFunctions[index] = 3;
          }
        });
        let params = {
          id: this.id,
          auditStatus: this.auditStatus === 0 ? 0 : 2,
          userId: myUser.id,
          userFunctions,
          certificateUrls: this.certificateUrls
        }
        const res = await this.catReq1Service(url, params)
        if (res.resultCode === "1") {
          this.isDis = true;
          this.$emit("succe", res.result)
        }
      }
    },
    cancel () {

      this.FormDataOne = { ...this.dataObj }
      this.$refs['ruleFormDataOne'].clearValidate();
      this.isDis = true;
    },
  },
};
</script>

<style lang="less" scoped>
.self_evaluation {
  .tabs {
    display: flex;
    font-size: 16px;
    align-items: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(28, 28, 29, 1);
    margin-bottom: 20px;
    span {
      width: 4px;
      height: 16px;
      background: rgba(30, 134, 230, 1);
      margin-right: 5px;
    }
    .tabs_one {
      width: 16px;
      height: 16px;
      cursor: pointer;
      display: inline-block;
      background: url("../../assets/imgs/authentication/modify_normal.png")
        no-repeat;
      background-size: cover;
      margin-left: 10px;
      &:active {
        background: url("../../assets/imgs/authentication/modify_press.png")
          no-repeat;
      }
    }
  }
  /deep/.el-form {
    .el-form-item {
      width: 100%;
      display: flex;
      .el-checkbox-group {
        text-align: left;
      }
    }
  }
  .add_work_experience {
    display: flex;
    cursor: pointer;
    float: left;
    margin-left: 10px;
    i {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      background: url("../../assets/imgs/editor/add_to_normal.png") no-repeat;
      background-size: cover;
    }
    span {
      display: inline-block;
      line-height: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-left: 5px;
    }
  }
  .btn {
    width: 100%;
    text-align: right;
    .el-button {
      width: 80px;
      height: 36px;
      box-sizing: border-box;
      font-family: Microsoft YaHei;
      font-size: 16px;
      line-height: 0;
    }
    .cancel {
      background: rgba(219, 239, 255, 1);
      border: 1px solid rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(153, 153, 153, 0.5);
      border-radius: 4px;
    }
    .preservation {
      background: rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(30, 134, 230, 0.5);
      border-radius: 4px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin-left: 50px;
    }
  }
}
</style>
